module.exports = __webpack_public_path__ + "img/workforce_admin.da4551c6.svg";